import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State {
  hasError: boolean;
}

/**
 * Jednoduchá chybová hranice webu. Na rozdíl od kořenové ErrorBoundary v apps/web chyby nikam
 * nehlásí: endpoint /api/client-errors je autentizovaný a na statickém webu není (Předpoklady FR01
 * 20261001_LandingPage/002_Marketing).
 */
export class LandingErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Chyba při vykreslení stránky', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }
    return (
      <div className="landing">
        <main className="container landing-error" role="alert">
          <h1>Stránku se nepodařilo zobrazit.</h1>
          <p>Zkuste ji prosím načíst znovu.</p>
          <a className="btn btn-primary" href="/">
            Zpět na úvod
          </a>
        </main>
      </div>
    );
  }
}
